import React, { useState } from 'react';

/**
 * TLDR Display Component
 * Shows the 5-bullet summary with copy functionality
 * Parent component provides the header/wrapper
 */
const TldrDisplay = ({ bullets }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const text = bullets.map((b, i) => `• ${b}`).join('\n');
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!bullets || bullets.length === 0) {
    return null;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '0.75rem' }}>
        <button
          onClick={handleCopy}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '32px',
            height: '32px',
            backgroundColor: copied ? '#198754' : '#f8f9fa',
            color: copied ? '#fff' : '#495057',
            border: '1px solid #dee2e6',
            borderRadius: '6px',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          title={copied ? 'Copied!' : 'Copy TLDR'}
        >
          <i className={`bi ${copied ? 'bi-check' : 'bi-files'}`}></i>
        </button>
      </div>
      <ul style={{
        margin: 0,
        paddingLeft: '1.25rem',
        listStyleType: 'disc'
      }}>
        {bullets.slice(0, 5).map((bullet, index) => (
          <li key={index} style={{
            marginBottom: index < bullets.length - 1 ? '0.5rem' : 0,
            lineHeight: '1.5',
            color: '#4a5568'
          }}>
            {bullet}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TldrDisplay;
